<template>
<div id="app">
    <router-view/>
</div>
</template>

<script>
export default {
    metaInfo: {
        titleTemplate: '%s | Cryprum',
        htmlAttrs: { lang: 'en' },
    },
}
</script>
